<template>
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="error-template">
          <h1>Oops!</h1>
          <h2>404 Not Found</h2>
          <div class="error-details">
            Sorry, an error has occured, Requested page not found!
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


  <script>
    export default {

      name: "PageNotFound",
      components: {
        
      },

      props: {

      },

      data() {
        return {
          forms: {},
        };
      },

      computed: {
        
      },

      watch: {

      },

      methods: {

      

      },


      events: {

      },

      created: function () {
        
      },

      mounted() {

        setTimeout(() => {
          window.location.href = 'https://lincgrp.com/';
        }, 5000); // 5000 milliseconds = 5 seconds


      },

      updated() {


      },

      onLoad(){


      }


    }
  </script>
<style scoped>
.error-template {padding: 40px 15px;text-align: center;}
.error-actions {margin-top:15px;margin-bottom:15px;}
.error-actions .btn { margin-right:10px; }
.container{
  align-content: center;
  height: auto;
}
</style>